import { memo } from "react";
import { Col, Container, Row } from "reactstrap";
import { TGeometry } from "../../../common/types/common";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import AreaItem from "./components/area-item";
import { getArea } from "./helper";
import Geometry from "@arcgis/core/geometry/Geometry";

interface Props {
    geometry?: TGeometry[] | null,
    errorMessage?: string,
}

const MapAreaBox = ({ geometry, errorMessage = '' }: Props) => {
    const geometryList = geometry ? geometry.map((item, index) => {
        const area = getArea(item);
        return <AreaItem area={area} index={index} key={`geometry-${index}`} />;
    }) : null;

    const totalArea = geometry ? getArea((geometryEngine as any).union(geometry as any as Geometry[])) : 0;

    return (
        <Container fluid className="d-flex flex-column h-100">
            <Row className="text-primary font-size-18">
                Map Areas:
            </Row>
            <Row className="flex-fill font-size-18 h-100 overflow-auto">
                <Col xl={12} className="p-0">
                    {errorMessage && (
                        <div className="text-danger fs-6 mt-2 ps-0">
                            {errorMessage}
                        </div>
                    )}
                    {geometryList && (
                        <Container fluid>
                            {geometryList}
                        </Container>
                    )}
                </Col>
            </Row>
            <Row className="text-muted font-size-18 mt-4">
                <Col xl={12} className="text-muted font-size-18 ps-0">
                    Total Job Acreage
                    <div className="text-primary">{totalArea} Acres</div>
                </Col>
            </Row>
        </Container>
    );
};

export default memo(MapAreaBox);
